module.exports = __webpack_public_path__ + "static/media/banner_new_pago_rapido_mobile.8cb57434.png";